module.exports = __webpack_public_path__ + "static/media/world_05.574ab4fc.png";